import {
  EventLog,
  EventSources,
  EventTypes,
  SessionData,
  Url,
  UserInformation,
} from "../interfaces";
import Cookies from "js-cookie";

export const getAllEventData = (userData: any, ip: any) => {
  const data: any = window.navigator;
  console.log("event data", data);

  let Session: SessionData = {
    source: EventSources.WEB,
    os: data.userAgentData.platform,
    timezone: new Date().getTimezoneOffset.toString(),
    webVersion: "",
    userAgent: data.userAgent,
    userIpV4: ip.IPV4, // make sure this is v4 only
    userIpV6: ip.IPV6, // make sure this is v6 only
    fbp: Cookies.get("_fbp"), // _fbp
    fbc: Cookies.get("_fbc"), // _fbc
    gclid: Cookies.get("_gid"),
    ga4ClientID: "",
    uaId: Cookies.get("_ga"),
  };

  let UserInfo: UserInformation = {
    sessionId: userData.sessionId,
    userId: userData.userId,
    anonymousId: userData.anonymousId,
    isAnonymous: true,
    sessionData: Session,
    phoneNumber: userData.phoneNumber,
  };

  let UrlData: Url = {
    domain: userData.locationData.domain,
    path: userData.locationData.path,
    query: userData.locationData.query,
    type: "",
  };

  const UserEventData = {
    category: userData.category,
    subcategory: userData.subcategory,
    name: userData.name,
  };

  const EventLogData: EventLog = {
    eventId: "",
    userInformation: UserInfo,
    // @ts-ignore
    type: EventTypes[userData.actionType],
    url: UrlData,
    timestamp: "", //iso
    eventData: UserEventData,
  };

  return EventLogData;

  // const EventSources : EventSources =
};
